// extracted by mini-css-extract-plugin
export var component = "NoticeModule-module--component--lb9XS";
export var hasIcon = "NoticeModule-module--hasIcon--pgiVz";
export var icon = "NoticeModule-module--icon--S7u5r";
export var title = "NoticeModule-module--title--6ka-J";
export var content = "NoticeModule-module--content--e21Wt";